import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '../_services/user.service';

@Component({
    selector: 'app-board-monitor',
    templateUrl: './board-monitor.component.html',
    styleUrls: ['./board-monitor.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BoardMonitorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }
}
